import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import UserContext from '../../components/User_Context.js';
import * as menu from "../../assets/menus/darm_menu.js";
import { sendMessage } from "../../api/apiConnector.js";
import * as api from "../../api/apiConnector.js";

const ReportsDashboard = () => {
    const { currentUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [reportsBySet, setReportsBySet] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const instance = process.env.REACT_APP_POWERBI_INSTANCE;

    useEffect(() => {
        if (currentUser && currentUser()) {
            menu.write({ user: currentUser() });
            loadReports();
        }
    }, [currentUser]);

    const loadReports = async () => {
        try {
            setLoading(true);
            setError(null);


            const response = await api.sendMessage("darm/power-bi/reports-by-set", {
                user: currentUser(),
                body: { 
                    instance: instance
                }
              });
            
            if (response.success) {
                setReportsBySet(response.reportsBySet);
            } else {
                setError(response.message || 'Error loading reports');
            }
        } catch (err) {
            console.error('Error loading reports:', err);
            setError('Failed to load reports. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleReportClick = (reportKey) => {
        navigate(`/darm/reports/${reportKey}`);
    };

    const renderReportCard = (report, setName) => (
        <div key={`${setName}-${report.id}`} className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <div className="card report-card h-100" style={{ cursor: 'pointer', position: 'relative' }}
                 onClick={() => handleReportClick(report.key)}>
                <div className="card-header border-0 pb-0">
                    <div className="header-info">
                        <h4 className="card-title mb-1">{report.nome}</h4>
                        <small className="text-muted">Report Key: {report.key}</small>
                    </div>
                    <div className="card-action" style={{ position: 'absolute', top: '15px', right: '15px' }}>
                        <i className="fa fa-chart-line text-primary" style={{ fontSize: '24px' }}></i>
                    </div>
                </div>
                <div className="card-body pt-2">
                    <p className="card-text text-muted mb-3">{report.descrizione}</p>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="badge badge-primary badge-xs light">{setName === 'noset' ? 'No Set' : setName}</div>
                        <small className="text-muted">
                            <i className="fa fa-external-link-alt me-1"></i>
                            Click to view
                        </small>
                    </div>
                </div>
            </div>
        </div>
    );

    const renderSetSection = (setName, reports) => {
        const displaySetName = setName === 'noset' 
            ? 'Report senza categorie'
            : setName;
        
        return (
            <div key={setName} className="mb-5">
                <div className="row mb-3">
                    <div className="col-12">
                        <div className="d-flex align-items-center mb-3">
                            <h3 className="mb-0 me-3">{displaySetName}</h3>
                            <span className="badge badge-outline-primary">{reports.length} report</span>
                        </div>
                        <hr className="mb-4" />
                    </div>
                </div>
                <div className="row">
                    {reports.map(report => renderReportCard(report, setName))}
                </div>
            </div>
        );
    };

    if (loading) {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                                <p className="mt-3 mb-0">
                                    Caricamento report...
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body text-center py-5">
                                <div className="text-danger mb-3">
                                    <i className="fa fa-exclamation-triangle" style={{ fontSize: '48px' }}></i>
                                </div>
                                <h4 className="text-danger mb-3">
                                    Errore nel Caricamento dei Report
                                </h4>
                                <p className="text-muted mb-4">{error}</p>
                                <button className="btn btn-primary" onClick={loadReports}>
                                    <i className="fa fa-refresh me-2"></i>
                                    Riprova
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const hasReports = Object.keys(reportsBySet).length > 0;
    const totalReports = hasReports 
        ? Object.values(reportsBySet).reduce((total, reports) => total + reports.length, 0)
        : 0;

    return (
        <div className="container-fluid">
            {/* Page Header */}
            <div className="row">
                <div className="col-12">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm-6">
                                <h1 className="page-title">
                                    <i className="fa fa-chart-pie me-2"></i>
                                    Dashboard Report
                                </h1>
                                <p className="page-description text-muted">
                                    Accedi e visualizza tutti i report PowerBI disponibili organizzati per categorie
                                </p>
                            </div>
                            <div className="col-sm-6">
                                <div className="text-sm-end">
                                    <div className="btn-group" role="group">
                                        <button type="button" className="btn btn-outline-primary" onClick={loadReports}>
                                            <i className="fa fa-refresh me-2"></i>
                                            Aggiorna
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Statistics Row */}
            {hasReports && (
                <div className="row mb-4">
                    <div className="col-xl-3 col-lg-6 col-md-6">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                        <h2 className="mb-1 text-primary">{totalReports}</h2>
                                        <p className="mb-0 text-muted">
                                            Report Totali
                                        </p>
                                    </div>
                                    <div className="icon-box bg-primary-light">
                                        <i className="fa fa-chart-bar text-primary"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-6">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                        <h2 className="mb-1 text-success">{Object.keys(reportsBySet).length}</h2>
                                        <p className="mb-0 text-muted">
                                            Categorie
                                        </p>
                                    </div>
                                    <div className="icon-box bg-success-light">
                                        <i className="fa fa-tags text-success"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-6">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                        <h2 className="mb-1 text-warning">{reportsBySet.noset?.length || 0}</h2>
                                        <p className="mb-0 text-muted">
                                            Non Categorizzati
                                        </p>
                                    </div>
                                    <div className="icon-box bg-warning-light">
                                        <i className="fa fa-question-circle text-warning"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-6">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                        <h2 className="mb-1 text-info">{instance || 'N/A'}</h2>
                                        <p className="mb-0 text-muted">
                                            Istanza
                                        </p>
                                    </div>
                                    <div className="icon-box bg-info-light">
                                        <i className="fa fa-server text-info"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Reports Content */}
            {hasReports ? (
                <div className="row">
                    <div className="col-12">
                        {Object.entries(reportsBySet)
                            .sort(([a], [b]) => {
                                // Sort so 'noset' appears last
                                if (a === 'noset' && b !== 'noset') return 1;
                                if (b === 'noset' && a !== 'noset') return -1;
                                return a.localeCompare(b);
                            })
                            .map(([setName, reports]) => renderSetSection(setName, reports))
                        }
                    </div>
                </div>
            ) : (
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body text-center py-5">
                                <div className="text-muted mb-3">
                                    <i className="fa fa-chart-pie" style={{ fontSize: '64px', opacity: 0.3 }}></i>
                                </div>
                                <h4 className="text-muted mb-3">
                                    Nessun Report Disponibile
                                </h4>
                                <p className="text-muted">
                                    Non ci sono report configurati per questa istanza.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ReportsDashboard;
